var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4183 0 16 3.58172 16 8L16 18H0V8C0 3.58172 3.58172 0 8 0Z",
    fill: "url(#paint0_linear_134_148781)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C19.5817 0 16 3.58172 16 8L16 18H32V8C32 3.58172 28.4183 0 24 0Z",
    fill: "url(#paint1_linear_134_148781)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13C24 8.58172 20.4183 5 16 5C11.5817 5 8 8.58172 8 13C8 17.4183 11.5817 21 16 21C20.4183 21 24 17.4183 24 13Z",
    fill: "url(#paint2_linear_134_148781)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9983 7.83203H31.9937C31.8009 12.9115 26.9689 17 22 17C17.5817 17 14 20.3579 14 24.5C14 28.6421 17.5817 32 22 32C22.0764 32 22.1526 31.999 22.2286 31.997V32C30.4571 32 32 24.1458 32 20.5V8C32 7.94387 31.9994 7.88788 31.9983 7.83203Z",
    fill: "url(#paint3_linear_134_148781)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8V20.5C0 24.1458 1.54286 32 9.77143 32V31.997C9.84736 31.999 9.92355 32 10 32C14.4183 32 18 28.6421 18 24.5C18 20.3579 14.4183 17 10 17C5.03105 17 0.199129 12.9115 0.00629317 7.83203H0.00172835C0.000577993 7.88788 0 7.94387 0 8Z",
    fill: "url(#paint4_linear_134_148781)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_148781",
    x1: 3,
    y1: 15.6667,
    x2: 6.52301,
    y2: -1.02832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F91F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_134_148781",
    x1: 26.6805,
    y1: 2.47731,
    x2: 18.6667,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926632,
    stopColor: "#155EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_134_148781",
    x1: 13.8333,
    y1: 7.16667,
    x2: 21.6667,
    y2: 22.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413439,
    stopColor: "#53ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_134_148781",
    x1: 19.7736,
    y1: 19.4194,
    x2: 28.113,
    y2: 33.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0799194,
    stopColor: "#4AC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_134_148781",
    x1: 3.41586,
    y1: 13.8763,
    x2: 11.1995,
    y2: 33.1337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F91F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053377"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViva);
export default __webpack_public_path__ + "static/media/viva.584a107f5a56b35d83e698b65ca8982d.svg";
export { ForwardRef as ReactComponent };